import React from 'react';
import { Calendar, CalendarDays, Clock, MapPin, Users } from 'lucide-react';
import './EventPreviewCard.css';

interface EventPreviewData {
  title: string;
  date: string;
  time: string;
  location?: string;
  attendees?: string[];
}

interface EventPreviewCardProps {
  event: EventPreviewData;
  actionId: string;
  onConfirm: () => void;
  onEdit?: () => void;
}

const EventPreviewCard: React.FC<EventPreviewCardProps> = ({
  event,
  actionId,
  onConfirm,
  onEdit,
}) => {
  return (
    <div className="event-preview-card">
      <div className="event-preview-header">
        <span className="event-icon"><Calendar size={24} aria-hidden="true" /></span>
        <h4 className="event-title">{event.title}</h4>
      </div>

      <div className="event-preview-details">
        <div className="detail-row">
          <span className="detail-icon"><CalendarDays size={16} aria-hidden="true" /></span>
          <span className="detail-text">{event.date}</span>
        </div>
        <div className="detail-row">
          <span className="detail-icon"><Clock size={16} aria-hidden="true" /></span>
          <span className="detail-text">{event.time}</span>
        </div>
        {event.location && (
          <div className="detail-row">
            <span className="detail-icon"><MapPin size={16} role="img" aria-label="Location" /></span>
            <span className="detail-text">{event.location}</span>
          </div>
        )}
        {event.attendees && event.attendees.length > 0 && (
          <div className="detail-row">
            <span className="detail-icon"><Users size={16} role="img" aria-label="Attendees" /></span>
            <span className="detail-text">{event.attendees.join(', ')}</span>
          </div>
        )}
      </div>

      <div className="event-preview-actions">
        {onEdit && (
          <button className="btn btn-secondary" onClick={onEdit}>
            Edit
          </button>
        )}
        <button className="btn btn-primary" onClick={onConfirm}>
          Add to Calendar
        </button>
      </div>
    </div>
  );
};

export default EventPreviewCard;
